<ng-container>
    <app-indication-list>
        [indications] = "indications$ | async">
    </app-indication-list>
</ng-container>
